var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H14C14 2.45 13.55 2 13 2H11C10.45 2 10 2.45 10 3H7C5.35 3 4 4.35 4 6V19C4 20.65 5.35 22 7 22H17C18.65 22 20 20.65 20 19V6C20 4.35 18.65 3 17 3ZM18 19C18 19.55 17.55 20 17 20H7C6.45 20 6 19.55 6 19V6C6 5.45 6.45 5 7 5H8C8 5.55 8.45 6 9 6H15C15.55 6 16 5.55 16 5H17C17.55 5 18 5.45 18 6V19ZM17 14C17 14.55 16.55 15 16 15H15L13.8 16.6C13.61 16.85 13.31 17 13 17C12.93 17 12.87 17 12.8 16.98C12.42 16.9 12.12 16.62 12.03 16.24L11.19 12.86L10.9 13.44C10.73 13.78 10.38 13.99 10.01 13.99H8.01C7.46 13.99 7.01 13.54 7.01 12.99C7.01 12.44 7.46 11.99 8.01 11.99H9.39L10.61 9.54C10.8 9.17 11.19 8.95 11.61 8.99C12.03 9.04 12.37 9.34 12.47 9.74L13.46 13.7L13.7 13.38C13.89 13.13 14.19 12.98 14.5 12.98H16C16.55 12.98 17 13.43 17 13.98V14Z",
    fill: "#585A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicExam);
export default __webpack_public_path__ + "static/media/medic_exam.bcd47d56434048b5294d249850d22913.svg";
export { ForwardRef as ReactComponent };